import api from './api';

const bookService = {
  // Récupérer tous les livres
  getAllBooks: async (params = {}) => {
    try {
      const response = await api.get('/books/', { params });
      console.log('Réponse axios complète:', response);
      console.log('Données de la réponse:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des livres:', error);
      throw error;
    }
  },

  // Rechercher des livres
  searchBooks: async (query, page = 1) => {
    try {
      const params = {
        q: query,
        page: page
      };
      const response = await api.get('/books/search/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des livres:', error);
      throw error;
    }
  },

  // Récupérer un livre par son ID
  getBookById: async (id) => {
    try {
      const response = await api.get(`/books/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du livre ${id}:`, error);
      throw error;
    }
  },

  // Créer un nouveau livre
  createBook: async (bookData) => {
    try {
      let formData;
      
      // Si bookData est déjà un FormData, l'utiliser directement
      if (bookData instanceof FormData) {
        formData = bookData;
      } else {
        // Sinon, créer un objet FormData pour envoyer les données du formulaire
        formData = new FormData();
        
        // Ajouter le titre s'il est défini
        if (bookData.title) {
          formData.append('title', bookData.title);
        }
        
        // Ajouter le fichier PDF s'il est défini
        if (bookData.pdf_file) {
          formData.append('pdf_file', bookData.pdf_file);
        }
        
        // Ajouter le fichier JSON de structure s'il est défini
        if (bookData.json_structure_file) {
          formData.append('json_structure_file', bookData.json_structure_file);
        }
      }
      
      // Utiliser api pour les requêtes avec des fichiers
      const response = await api.post('/books/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du livre:', error);
      throw error;
    }
  },

  // Importer un livre depuis un fichier JSON exporté (sans PDF)
  importBookFromJson: async (data) => {
    try {
      let formData;

      if (data instanceof FormData) {
        formData = data;
      } else {
        formData = new FormData();
        if (data.title) {
          formData.append('title', data.title);
        }
        if (data.json_structure_file) {
          formData.append('json_structure_file', data.json_structure_file);
        }
        if (typeof data.generate_qcm !== 'undefined') {
          formData.append('generate_qcm', data.generate_qcm ? 'true' : 'false');
        }
        if (typeof data.nb_questions_per_chapter !== 'undefined') {
          formData.append('nb_questions_per_chapter', String(data.nb_questions_per_chapter));
        }
      }

      const response = await api.post('/books/import-structure/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'import du livre depuis le JSON:", error);
      throw error;
    }
  },

  // Mettre à jour un livre
  updateBook: async (id, bookData) => {
    try {
      const response = await api.patch(`/books/${id}/`, bookData);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du livre ${id}:`, error);
      throw error;
    }
  },

  // Supprimer un livre
  deleteBook: async (id) => {
    try {
      const response = await api.delete(`/books/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression du livre ${id}:`, error);
      throw error;
    }
  },

  // Récupérer les livres récents (créés dans les 7 derniers jours)
  getRecentBooks: async () => {
    try {
      const response = await api.get('/books/recent/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des livres récents:', error);
      throw error;
    }
  },

  // Fusionner deux livres (API /books/{id}/merge/)
  mergeBooks: async (targetBookId, { otherBookId, keepTitle = 'current', keepCover = 'current' }) => {
    try {
      const payload = {
        other_book_id: otherBookId,
        keep_title: keepTitle,
        keep_cover: keepCover,
      };
      const response = await api.post(`/books/${targetBookId}/merge/`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la fusion des livres:', error);
      throw error;
    }
  },

  // Fusionner plusieurs livres dans un seul (API /books/merge-multiple/)
  mergeMultipleBooks: async ({ bookIds, targetBookId, keepTitleFromId, keepCoverFromId }) => {
    try {
      const payload = {
        book_ids: bookIds,
        target_book_id: targetBookId,
        keep_title_from_id: keepTitleFromId,
        keep_cover_from_id: keepCoverFromId,
      };
      const response = await api.post('/books/merge-multiple/', payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la fusion multiple des livres:', error);
      throw error;
    }
  },

  // Prévisualiser la fusion multiple (chapitres par livre) sans rien modifier
  mergeMultiplePreview: async (bookIds) => {
    try {
      const payload = { book_ids: bookIds };
      const response = await api.post('/books/merge-multiple-preview/', payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la prévisualisation de la fusion multiple:', error);
      throw error;
    }
  },

  // Créer un nouveau livre fusionné en dupliquant uniquement les chapitres sélectionnés
  mergeMultipleCreate: async ({ bookIds, metaFromBookId, keepTitleFromId, keepCoverFromId, includedChapterIds }) => {
    try {
      const payload = {
        book_ids: bookIds,
        meta_from_book_id: metaFromBookId,
        keep_title_from_id: keepTitleFromId,
        keep_cover_from_id: keepCoverFromId,
        included_chapter_ids: includedChapterIds,
      };
      const response = await api.post('/books/merge-multiple-create/', payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du livre fusionné:', error);
      throw error;
    }
  },

  // Analyser un livre (si vous avez un endpoint spécifique pour l'analyse)
  analyzeBook: async (id) => {
    try {
      const response = await api.post(`/books/${id}/analyze/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de l'analyse du livre ${id}:`, error);
      throw error;
    }
  },
};

export default bookService;
